import { redirectToHomeIfNoDataAccess } from '@/data/router/guards';

const DataPage = () => import('@/data/pages/data.vue');
const DataIngestionHistoryPage = () => import('@/data/pages/data-ingestion-history.vue');

export const dataRoutes = [
  {
    path: '/data',
    name: 'data',
    component: DataPage,
    beforeEnter: redirectToHomeIfNoDataAccess,
  },
  {
    path: '/data/history',
    name: 'data-history',
    component: DataIngestionHistoryPage,
    beforeEnter: redirectToHomeIfNoDataAccess,
  },
];
